import axios from 'axios'
import { grid } from '../../display'

const namespaced = true

const state = {
  calcVars: null,
  floor: 1,
  zoom: 3,
  temporaryItem: null,
  // editingItemId: null,
  inspectItem: null,
}

const getters = {
  initialized(state) {
    return state.calcVars != null
  },
  getCalcVars: state => (category, number_no, type_no, selection_no = null) => {
    if (state.calcVars == null) {
      return null
    }
    if (selection_no == null) {
      return parseFloat(_.get(state.calcVars, [category, number_no, type_no], null))
    } else {
      return parseFloat(_.get(state.calcVars, [category, number_no, type_no, selection_no], null))
    }
  },
}

const actions = {
  fetchRemoteCalcVars({ commit }) {
    return axios.request({
      url: '/apis/getCalcVars',
      method: 'get',
      headers: { 'Accept-Language': 'ja,en-US;q=0.9,en;q=0.8' },
      responseType: 'json',
    })
    .then(response => {
      commit('setCalcVars', response.data.dataset)
    })
  },
  updateFloor({ commit }, floor) {
    commit('setEditorFloor', floor)
  },
  updateZoom({ commit }, zoom) {
    commit('setEditorZoom', zoom)
  },
  // editItem({ commit }, item) {
  //   commit('setEditingItemId', item.id)
  // },
  // blurItem({ commit }) {
  //   commit('setEditingItemId', null)
  // },
  inspect({ commit }, item) {
    commit('setInspectItem', item)
  },
}

const mutations = {
  setCalcVars(state, vars) {
    state.calcVars = vars
  },
  setEditorFloor(state, floor) {
    state.floor = floor
  },
  setEditorZoom(state, zoom) {
    state.zoom = zoom
  },
  setTemporaryItem(state, itemId) {
    state.temporaryItem = itemId
  },
  // setEditingItemId(state, itemId) {
  //   state.editingItemId = itemId
  // },
  setInspectItem(state, item) {
    state.inspectItem = item
  },
}

export default {
  namespaced,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./assets/js/store/modules/editor.js